exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menuContent main {\n  padding: 10px;\n  box-sizing: border-box;\n}\n.menuContent .title {\n  font-size: 20px;\n  font-weight: bold;\n  margin: 14px 0px 9px 10px;\n}\n.menuContent .dishesContainer {\n  overflow: auto;\n}\n.menuContent .dish {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px 5px 10px;\n}\n.menuContent .dish .dishimage {\n  width: 80px;\n  padding-top: 80px;\n  margin-right: 10px;\n  background-size: cover;\n  background-position: center;\n  flex-shrink: 0;\n  box-shadow: 1px 1px 6px 0 rgba(50, 41, 41, 0.1);\n  border-radius: 4px;\n}\n.menuContent .dish .texts {\n  flex-grow: 2;\n}\n.menuContent .dish .texts .dishtitle {\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n}\n.menuContent .dish .texts .dishdescription {\n  text-align: left;\n  color: #2E2E2E;\n  font-size: 14px;\n  line-height: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/products/MenuContent.less
// module id = 1372
// module chunks = 0